import { RadioGroup } from '@headlessui/react';
import { useEffect, useState } from 'react';
import { Label, Textarea } from '@components/common/Forms';
import { useTranslation } from 'next-i18next';

export const StepAskReason = ({ setReason, setOtherReason }: { setReason: (reasonId: number) => void, setOtherReason: (reasonText: string) => void }) => {
  const [responseReason, setResponseReason] = useState<number | null>();
  const [showTextArea, setShowTextArea] = useState<boolean>(false);

  // Translation
  const { t } = useTranslation('common');

  const reasons = [
    { id: 1, name: t('premium.talent.closeRequest.reason.1.text') },
    { id: 2, name: t('premium.talent.closeRequest.reason.2.text') },
    { id: 3, name: t('premium.talent.closeRequest.reason.3.text') },
    { id: 4, name: t('premium.talent.closeRequest.reason.4.text') },
    { id: 0, name: t('premium.talent.closeRequest.reason.other.text') },
  ];
  const radioTypeButtonUnchecked = () => (
    <div className="absolute left-px top-px size-3.5 rounded-full border border-yellow-400 bg-white" />
  );

  const radioTypeButtonChecked = () => (
    <div className="absolute left-px top-px size-3.5 rounded-full border border-yellow-400 bg-yellow-400" />
  );

  const handleReasonChange = (radioInputId: number) => {
    setResponseReason(radioInputId);
    setReason(radioInputId);
  };

  // Check for reason ID and show text area if reason is other
  useEffect(() => {
    if (responseReason === 0) {
      setShowTextArea(true);
    } else {
      setShowTextArea(false);
    }
  }, [responseReason]);

  // Render component
  // *****************************************

  return (
    <div>
      <div className="flex items-center self-stretch">
        <div className="flex-basis-0 grow text-xl font-bold leading-[30px] text-ink-medium">
          {t('premium.talent.closeRequest.reasons.heading')}
        </div>
        <div className="flex justify-end">
          <span className="px-1 text-secondary">2</span>
          <span className="px-1">/</span>
          <span className="px-1">2</span>
        </div>
      </div>


      <hr className="my-6 border-gray-400" />

      {/* radio group */}
      <RadioGroup className="flex flex-col items-start justify-start gap-4" onChange={handleReasonChange}>
        {reasons.map((reason) => (
          <RadioGroup.Option key={reason.id} value={reason.id}>
            {({ checked }) => (
              <div className="inline-flex items-center justify-start gap-2 self-stretch">
                <div className="relative size-4">
                  { checked ? radioTypeButtonChecked() : radioTypeButtonUnchecked()}
                </div>
                <div className="shrink grow basis-0 text-base leading-normal text-ink">
                  {reason.name}
                </div>
              </div>
            )}
          </RadioGroup.Option>
        ))}
      </RadioGroup>

      {showTextArea && (
      <Label
        description={t('premium.talent.closeRequest.provideAnswer')}
        descriptionClass="text-md font-bold"
        required
      >
        <Textarea
          minLength={5}
          required
          placeholder={t('global.placeholder.answer')}
          onChange={(e) => setOtherReason(e.target.value)}
        />
      </Label>
      )}
    </div>
  );
};
